// tslint:disable:max-line-length

import React from 'react';

export const ArrowChevronUp = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M8,2.5L6.6,3.7L0,8.9v4.6l0.1-0.1L8,7l8,6.4V9L9.4,3.7L8,2.5L8,2.5z" />
    </svg>
  );
};
